export const sidebarLinks = [
  {
    imgURL: "/assets/icons/home.svg",
    route: "/",
    label: "Home",
  },
  {
    imgURL: "/assets/icons/home.svg",
    route: "/trust-score",
    label: "Trustscore Dashboard",
  },
  {
    imgURL: "/assets/icons/explore.svg",
    route: "/explore",
    label: "Explore",
  },
  {
    imgURL: "/assets/icons/message.svg",
    route: "/chats",
    label: "Messages",
  },
  {
    imgURL: "/assets/icons/live.svg", 
    route: "/live",
    label: "Live Stream",
  },
  {
    imgURL: "/assets/icons/business-owner.svg",
    route: "/sellers",
    label: "Sellers",
  },
  {
    imgURL: "/assets/icons/marketing.svg",
    route: "/bizz",
    label: "Bizz",
  },
  {
    imgURL: "/assets/icons/bookmark.svg",
    route: "/saved",
    label: "Saved",
  },
  {
    imgURL: "/assets/icons/gallery-add.svg",
    route: "/create-post",
    label: "Create Post",
  },
  {
    imgURL: "/assets/icons/terms_conditions.svg",
    route: "/termandcondition",
    label: "Terms & Conditions",
  },
  {
    imgURL: "/assets/icons/privacy_policy.svg",
    route: "/privacy-policies",
    label: "Privacy Policy",
  },
];

export const bottombarLinks = [
    {
    imgURL: "/assets/icons/business-owner.svg",
    route: "/sellers",
    label: "Sellers",
  },
  {
    imgURL: "/assets/icons/marketing.svg",
    route: "/bizz",
    label: "Bizz",
  },
  {
    imgURL: "/assets/icons/live.svg", 
    route: "/live",
    label: "Live",
  },
  {
    imgURL: "/assets/icons/message.svg",
    route: "/chats",
    label: "Chats",
  },
  {
    imgURL: "/assets/icons/gallery-add.svg",
    route: "/create-post",
    label: "Add Post",
  },
];

